import React from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'react-router/lib/Link';
import suitcss from '../../../helpers/suitcss';
import connectUI from '../../basics/ui/UIConnector';

import { shape as tariffShape } from '../../../propTypes/tariff';
import { imageShape } from '../../../propTypes/media';
import imageSizes from '../../../config/imageSizes';

import Copy from '../../basics/text/TextCopy';
import Unit from '../../basics/text/TextUnit';
import Callout from '../../../containers/callout/Callout';
import MediaImageBackground from '../../basics/media/MediaImageBackground';
import FootnoteReference from '../../../containers/footnote/FootnoteReference';

function HeaderItemTariff(props) {
  const { copy, image, tariff, link, featured, ui } = props;
  const linkTo = link || {
    title: ui.guiWordDetails,
    url: tariff.urlDetails,
  };
  const backgroundImage = {
    ...image,
    sizes: imageSizes[featured ? 'headerItemBackgroundFeatured' : 'headerItemBackground'],
  };
  return (
    <MediaImageBackground
      className={suitcss({
        componentName: 'HeaderStageItem',
        modifiers: [
          'typeTariff',
          featured && 'featured',
        ],
      })}
      {...backgroundImage}
      isLazy
    >
      <RouterLink
        className={suitcss({
          componentName: 'HeaderStageItem',
          descendantName: 'ctaOverlay',
        })}
        to={linkTo.url}
        target={linkTo.target}
      />
      <div
        className={suitcss({
          componentName: 'HeaderStageItem',
          descendantName: 'inner',
        })}
      >
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'content',
          })}
        >
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'paymentFee',
            })}
          >
            <Unit
              size="s"
              price={tariff.paymentFee}
              postfix={[ui.guiWordMonthlyAbbr, <FootnoteReference id={tariff.eid} />]}
            />
          </div>
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'copy',
            })}
          >
            <Copy raw embedded inverted>
              {copy}
            </Copy>
          </div>
        </div>
        <Callout
          theme="badge"
          targets={[tariff.eid]}
          inverted
        />
      </div>
    </MediaImageBackground>
  );
}

HeaderItemTariff.propTypes = {
  copy: PropTypes.string,
  link: PropTypes.object,
  image: imageShape,
  tariff: tariffShape,
  featured: PropTypes.bool,
  ui: PropTypes.shape({
    guiWordDetails: PropTypes.string.isRequired,
    guiWordMonthlyAbbr: PropTypes.string.isRequired,
  }),
};

HeaderItemTariff.defaultProps = {};

export default connectUI()(HeaderItemTariff);
